import { Link } from "react-router-dom";
import { Button, Card, CardActions, CardContent, CardMedia, Typography } from "@mui/material";

import "./ClassCard.css";
import cardImg from "./1b.png";

function ClassCard() {
  return (
    <Card className="teacher-class-card" variant="outlined">
      <CardMedia component="img" image={cardImg} alt="1-Б клас" />
      <CardContent>
        <Typography variant="h6">1-Б клас</Typography>
      </CardContent>
      <CardActions>
        <Button component={Link} to="/teacher/class/1b" variant="contained">
          Перейти до класу
        </Button>
      </CardActions>
    </Card>
  );
}

export default ClassCard;
